module.exports = __webpack_public_path__ + "img/epic-adventures.2f862b27.jpeg";